<template>
    <div class="box">
        <div v-if="formData.expenseDescription">
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>费用包含</div>
            </div>
            <div class="content">
                <span></span>
                <div v-html="formData.expenseDescription"/>
            </div>
        </div>
        <div v-if="formData.expenseDescriptionExclusive	">
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>费用不包含</div>
            </div>
            <div class="content">
                <span></span>
                <div v-html="formData.expenseDescriptionExclusive"/>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'DetailPageTemplate',
    props: {
      expenseDescription:{
        type:String,
        // default:""
      },
      expenseDescriptionExclusive:{
        type:String,
        // default:""
      }
    },
    data() {
      return {
        formData: {
          expenseDescription: '',
          expenseDescriptionExclusive: ''
        }, // 行程信息
      }
    },
    watch:{
      expenseDescription(val){
        this.formData.expenseDescription = val
      },
      expenseDescriptionExclusive(val){
        this.formData.expenseDescriptionExclusive = val
      }
    },
    mounted() {
        this.formData = {
          expenseDescription: this.expenseDescription,
          expenseDescriptionExclusive: this.expenseDescriptionExclusive,
        }
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
.box {
    padding: 0 vw(20);
    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        div {
            font-size: vw(28);
            margin-left:vw(20);
        }
    }
    .content {
        display: flex;
        color: #9c9c9c;
        justify-content: flex-start;
        font-size: vw(26);
        padding:vw(10) 0;
        span {
            // width: vw(1);
            margin: 0 vw(6);
            // background-color: #ddd;
        }
        div {
            margin-left: vw(10);
        }
    }
}

</style>

